import { roundToXDecimals } from '../numberUtils';

export function minutesSecondsToSeconds(duration) {
  if (!duration) return 0;
  const [minutes, seconds] = duration.split(':');
  return 60 * parseInt(minutes) + parseInt(seconds);
}

export function hasPassedNextProgressStep({
  progressStep,
  progressPrecission,
  lastProgress,
  playedPercent,
}) {
  const nextProgressUpdate = lastProgress + progressStep;
  return (
    // Be precise detecting step while playing
    Math.abs(playedPercent - nextProgressUpdate) < progressPrecission / 2 ||
    // Ensure detection if seeked way passed the next step
    playedPercent >= lastProgress + progressStep
  );
}

export function logSavingProgress(playedSeconds, taskDuration, realDuration) {
  console.log(
    'Saving progress at:',
    `${playedSeconds}s of ${taskDuration}s -- ${roundToXDecimals(
      (100 * playedSeconds) / taskDuration,
      2
    )}%`
  );
}
